import styled from '@emotion/styled'
import {
    breakpoint,
    calcRem,
    fonts,
    zIndex,
    colors,
} from '../../../../__styling'
import { StyledButton } from '../../../../buttons/Button/Button.styled'

export const StyledPurchaseCompletePrompt = styled.div({
    position: 'fixed',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: zIndex.thewest.flyoutNav,
    textAlign: 'center',
    background: 'rgba(0,0,0, 0.5)',
})

export const StyledPurchaseCompletePromptContainer = styled('div')<{
    loading: boolean
}>(({ theme, loading }) => ({
    position: 'relative',
    margin: calcRem(0, 0, 60, 0),

    borderRadius: calcRem(8),
    padding: loading ? calcRem(24) : calcRem(48, 24, 24, 24),
    width: 400,
    maxWidth: '90vw',
    height: 'fit-content',

    backgroundColor: theme.colors.background.primary,
}))

export const StyledTextContainer = styled('div')<{ loading: boolean }>(
    ({ loading }) => ({
        margin: loading ? 0 : `0 auto ${calcRem(24)} auto`,
        justifyContent: 'center',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
    }),
)

export const StyledPurchaseCompleteHeader = styled('h3')<{
    loading: boolean
}>(({ loading }) => ({
    color: colors.thewest.lightBlack,
    textAlign: 'center',
    margin: 0,
    padding: loading ? calcRem(16, 0, 0, 0) : calcRem(24, 0, 16, 0),

    fontFamily: fonts.thewest.serif,
    fontSize: calcRem(22),
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: calcRem(30),
}))

export const StyledPurchaseCompleteText = styled('p')<{
    loading: boolean
}>(({ loading }) => ({
    color: colors.thewest.greyElephant,
    textAlign: 'center',
    margin: 0,
    padding: loading ? calcRem(16, 0, 0, 0) : 0,

    /* body/S/sans/regular */
    fontFamily: fonts.thewest.sansSerif,
    fontSize: calcRem(16),
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: calcRem(24),
}))

export const StyledContinueButton = styled(StyledButton)({
    borderRadius: calcRem(2),
    height: calcRem(48),
    width: '100%',
    padding: calcRem(12, 24),

    textTransform: 'none',
    fontSize: calcRem(18),
    fontWeight: 500,
    lineHeight: calcRem(20),
    fontStyle: 'normal',

    [breakpoint('xs')]: {
        fontSize: calcRem(18),
    },
})
